import APIUtils from '@spothero/utils/api';
import Config from 'config';

async function matchPlaces(address) {
    const mapboxPlaces = 'https://api.mapbox.com/geocoding/v5/mapbox.places';
    const params = {
        // eslint-disable-next-line camelcase
        access_token: Config.mapboxToken,
        limit: 10,
        country: ['us', 'ca'],
        proximity: 'geoip-f033fe71-6733-4484-8445-6f6744bd0337',
    };

    const response = await APIUtils.get(
        `${mapboxPlaces}/${address}.json`,
        params
    );

    return response.data.features.map(feature => {
        return {
            search_string: feature.place_name, // eslint-disable-line camelcase
            label: feature.place_name,
            description: feature.place_name,
            id: feature.id,
            latitude: feature.center[1],
            longitude: feature.center[0],
        };
    });
}

export default matchPlaces;
